export default "__VITE_ASSET__DCVVSE78__"